export default "__VITE_ASSET__DE$5q2d8__"